import {useEffect} from 'react'
import {useMap} from 'react-leaflet'

const parkBounds = [
  [25.6775, -100.2868],
  [25.6828, -100.2774],
]

const tileCache = new Set()

const MapTilePreloader = ({url}) => {
  const map = useMap()

  useEffect(() => {
    const [southWest, northEast] = parkBounds

    for (let zoom = 16; zoom <= 18; zoom += 1) {
      const southWestTile = map.project(southWest, zoom).divideBy(256).floor()
      const northEastTile = map.project(northEast, zoom).divideBy(256).floor()

      for (let x = southWestTile.x - 1; x <= northEastTile.x + 1; x += 1) {
        for (let y = northEastTile.y - 1; y <= southWestTile.y + 1; y += 1) {
          const tileUrl = url
            .replace('{z}', zoom)
            .replace('{x}', x)
            .replace('{y}', y)

          if (tileCache.has(tileUrl)) continue

          tileCache.add(tileUrl)
          const image = new Image()
          image.src = tileUrl
        }
      }
    }
  }, [map, url])

  return null
}

export default MapTilePreloader
